import { Component } from '@angular/core';

@Component({
  selector: 'chubb-card',
  standalone: true,
  imports: [ ],
  templateUrl: './chubb-card.component.html',
  styleUrl: './chubb-card.component.scss'
})
export class ChubbCardComponent {
}
